import { Typography } from '@mui/material'

import useStyles from './index.styles'

const Nh3WarningBubble = ({ value, isOffline }: { value: number; isOffline: boolean }) => {
  const classes = useStyles

  return (
    <Typography variant="caption" color={isOffline ? 'divider' : 'textPrimary'} sx={classes.ammWarningLabel}>
      {value === 1 ? 'Detected' : 'Not detected'}
    </Typography>
  )
}

export default Nh3WarningBubble
